export default __webpack_public_path__ + "static/media/BOD Regular Meeting 20 August 2021.63d72359.pdf";